/* Nussknacker Reveal: Nüsse knacken, Karten zeigen, Bonus nach allen drei, Nussknacker beißt mit. Dazu der Kipferl-Rechner. */
(function () {
  function init(root) {
    if (!root || root.getAttribute('data-nk-ready')) return;
    root.setAttribute('data-nk-ready', '1');
    root.classList.remove('nk--nojs');
    root.classList.add('nk--js');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var nuts = Array.prototype.slice.call(root.querySelectorAll('[data-nk-nut]'));
    var bonus = root.querySelector('[data-nk-bonus]');
    var allBtn = root.querySelector('[data-nk-all]');
    var live = root.querySelector('[data-nk-live]');
    var stage = root.querySelector('[data-nk-stage]');
    var touched = false;

    function chomp() {
      if (!stage || reduce) return;
      stage.classList.remove('nk-chomp');
      void stage.getBoundingClientRect();
      stage.classList.add('nk-chomp');
    }
    if (stage) {
      stage.addEventListener('click', chomp);
      stage.addEventListener('animationend', function (e) {
        var c = e.target && e.target.classList;
        if (c && c.contains('nk-cracker__jaw')) stage.classList.remove('nk-chomp');
      });
      setTimeout(chomp, 900);
    }

    function isOpen(btn) { return btn.getAttribute('aria-expanded') === 'true'; }
    function update(announce) {
      var all = nuts.length > 0 && nuts.every(isOpen);
      var wasAll = root.classList.contains('nk--all');
      root.classList.toggle('nk--all', all);
      if (bonus) bonus.classList.toggle('is-open', all);
      if (allBtn) allBtn.hidden = all;
      if (all && !wasAll && announce && live && bonus) {
        var t = bonus.querySelector('.nk-bonus__title');
        if (t) live.textContent = t.textContent;
      }
    }
    function setOpen(btn, open, announce) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      var item = btn.closest('.nk-nut-item');
      if (item) item.classList.toggle('is-open', open);
      var card = document.getElementById(btn.getAttribute('aria-controls'));
      if (card) card.classList.toggle('is-open', open);
      if (open && announce && live) live.textContent = btn.getAttribute('data-nk-say') || '';
      if (open && !reduce && navigator.vibrate) { try { navigator.vibrate(16); } catch (e) {} }
      if (open) chomp();
      update(announce);
    }
    nuts.forEach(function (btn) {
      btn.addEventListener('click', function () {
        touched = true;
        btn.classList.remove('nk-hint');
        setOpen(btn, !isOpen(btn), true);
      });
    });
    if (allBtn) {
      allBtn.addEventListener('click', function () {
        touched = true;
        var closed = nuts.filter(function (b) { return !isOpen(b); });
        closed.forEach(function (btn, n) {
          setTimeout(function () { setOpen(btn, true, n === closed.length - 1); }, reduce ? 0 : n * 240);
        });
      });
    }
    update(false);
    if (!reduce && nuts[0]) {
      setTimeout(function () { if (!touched) nuts[0].classList.add('nk-hint'); }, 1800);
    }
    kipferl(root);
  }

  /* Kipferl-Rechner (Band „Bake the costume“). Die Grundmengen stehen in data-nk-kipferl,
     also in derselben Quelle wie die Zutatenliste ohne JS. Texte DE + EN, Zahlen von Weglot ausgenommen. */
  var EN = /^en/i.test(document.documentElement.getAttribute('lang') || '') || /^\/en(\/|$)/.test(location.pathname);
  var KT = EN ? {
    dec: '.',
    pinch: function (n) { return n === 1 ? '1 pinch' : n + ' pinches'; },
    sachet: function (n) { return n === 1 ? '1 sachet' : n + ' sachets'; },
    coffee: function (c, g, b, w) { return c + '\u00a0cups · ' + g + '\u00a0g\u00a0coffee\u00a0(' + (b === 1 ? '1\u00a0bag' : b + '\u00a0bags') + ') · ' + w + '\u00a0l\u00a0water'; },
    say: function (n, a, c) { return n + ' crescents: ' + a.flour + ' flour, ' + a.butter + ' butter, ' + a.sugar + ' icing sugar, ' + a.nuts + ' nuts. Plus ' + c + ' cups of coffee.'; },
    notes: {
      30: 'Half a batch. Enough for you and St Nick.',
      60: 'One batch of crescents, almost exactly one bag of Nutcracker.',
      120: 'Double batch, two bags of Nutcracker. Sounds like visitors.',
      180: '180 crescents, three bags of Nutcracker. You\u2019re baking for the whole street, aren\u2019t you?'
    }
  } : {
    dec: ',',
    pinch: function (n) { return n === 1 ? '1 Prise' : n + ' Prisen'; },
    sachet: function (n) { return n + ' Päckchen'; },
    coffee: function (c, g, b, w) { return c + '\u00a0Tassen · ' + g + '\u00a0g\u00a0Kaffee\u00a0(' + (b === 1 ? '1\u00a0Tüte' : b + '\u00a0Tüten') + ') · ' + w + '\u00a0l\u00a0Wasser'; },
    say: function (n, a, c) { return n + ' Kipferl: ' + a.flour + ' Mehl, ' + a.butter + ' Butter, ' + a.sugar + ' Puderzucker, ' + a.nuts + ' Nüsse. Dazu ' + c + ' Tassen Kaffee.'; },
    notes: {
      30: 'Halbes Rezept. Reicht für dich und den Nikolaus.',
      60: 'Ein Rezept Kipferl, fast genau eine Tüte Nussknacker.',
      120: 'Doppeltes Rezept, zwei Tüten Nussknacker. Klingt nach Besuch.',
      180: '180 Kipferl, drei Tüten Nussknacker. Du backst für die ganze Straße, oder?'
    }
  };
  function kipferl(root) {
    var box = root.querySelector('[data-nk-kipferl]');
    if (!box || box.getAttribute('data-nk-kready')) return;
    var c;
    try { c = JSON.parse(box.getAttribute('data-nk-kipferl')); } catch (e) { return; }
    box.setAttribute('data-nk-kready', '1');
    function el(k) { return box.querySelector('[data-nk-k="' + k + '"]'); }
    function set(k, t) { var e = el(k); if (e) e.textContent = t; }
    function r5(x) { return Math.max(5, Math.round(x / 5) * 5); }
    function r10(x) { return Math.round(x / 10) * 10; }
    function frac(x) {
      var whole = Math.floor(x + 1e-9), rest = Math.round((x - whole) * 4);
      if (rest === 4) { whole += 1; rest = 0; }
      return ((whole ? String(whole) : '') + (['', '\u00bc', '\u00bd', '\u00be'][rest] || '')) || '0';
    }
    var minus = el('minus'), plus = el('plus'), live = el('live');
    var n = c.count;
    function render(say) {
      var f = n / c.count;
      var a = { flour: r5(c.flour * f) + ' g', butter: r5(c.butter * f) + ' g', sugar: r5(c.sugar * f) + ' g', nuts: r5(c.nuts * f) + ' g' };
      set('count', n);
      set('flour', a.flour);
      set('butter', a.butter);
      set('sugar', a.sugar);
      set('nuts', a.nuts);
      set('salt', KT.pinch(Math.max(1, Math.ceil(n / c.count))));
      set('vanilla', frac(c.vanilla * f));
      set('dust', Math.max(c.dustMin, r10(c.dust * f)) + ' g');
      set('vsugar', KT.sachet(Math.max(1, Math.ceil(c.vsugar * f))));
      var cups = Math.ceil(n / c.perCup);
      var g = cups * c.cupCoffee;
      var bags = Math.ceil(g / c.bag);
      var w = (cups * c.cupWater / 1000).toFixed(2).replace(/\.?0+$/, '').replace('.', KT.dec);
      set('coffee', KT.coffee(cups, g, bags, w));
      set('note', KT.notes[n] || '');
      if (minus) minus.disabled = n <= c.min;
      if (plus) plus.disabled = n >= c.max;
      if (say && live) live.textContent = KT.say(n, a, cups);
    }
    if (minus) minus.addEventListener('click', function () { if (n > c.min) { n = Math.max(c.min, n - c.step); render(true); } });
    if (plus) plus.addEventListener('click', function () { if (n < c.max) { n = Math.min(c.max, n + c.step); render(true); } });
    render(false);
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-nk]'), init);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector('[data-nk]');
    if (r) init(r);
  });
})();
